export const SATELLITE_STYLE =
    'mapbox://styles/mapbox/satellite-streets-v11?optimize=true'
export const NORMAL_STYLE =
    'mapbox://styles/maserasti/cka9tdo440uq31iqvb0k4i1ng?optimize=true'
export const NORMAL_STYLE_COMPACT = 'maserasti/cka9tdo440uq31iqvb0k4i1ng'

export const BBOX =
    '-81.36876823216579,43.00750920478495,-77.35469838160704,44.938572495607815'

export const DEFAULT_LATITUDE = 43.73072
export const DEFAULT_LONGITUDE = -79.41907
export const DEFAULT_ZOOM = 13.5

export const CSS =
    'https://api.tiles.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.css'
export const CSS2 =
    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.2.2/mapbox-gl-draw.css'

export const DEFAULT_BOUNDS = [
    { latitude: 43.744304738777146, longitude: -79.44223896556389 },
    { latitude: 43.744304738777146, longitude: -79.39590103443722 },
    { latitude: 43.71713217923954, longitude: -79.39590103443722 },
    { latitude: 43.71713217923954, longitude: -79.44223896556389 },
    { latitude: 43.744304738777146, longitude: -79.44223896556389 },
]
